import { UUID } from "crypto";

export class FiltroUsuarioDTO {
  public idMatriz!: string;
  public idPromotora!: string;
  public idSupervisor!: string;
  public idOperador!: string;
  public idPontoVenda!: string;
  public codigo!: string;
  public login!: string;
  public nome!: string;
  public cpf!: string;
  public status!: boolean | null;
  public idRole!: UUID;
  public dataInicio!: Date;
  public dataFim!: Date;
}